import "swiper/css";
import { Swiper } from "swiper/react";
import { FancyBox } from "~/modules/shared/components";

type ProductsSliderProps = {
  children: React.ReactNode;
};

export function ProductsSlider({ children }: ProductsSliderProps) {
  return (
    <FancyBox
      options={{
        Hash: false,
      }}
    >
      <Swiper
        spaceBetween={20}
        slidesPerView={1}
        breakpoints={{
          480: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
          1400: {
            slidesPerView: 4,
          },
          1600: {
            slidesPerView: 5,
          },
        }}
        className="h-full w-full"
      >
        {children}
      </Swiper>
    </FancyBox>
  );
}
